export default __webpack_public_path__ + "static/media/EiglophianMountains.5504cb7e.jpg";